import TableWrapper from "../../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import CommonHeader from "../../../../Components/Common/CommonHeader/CommonHeader";
import { useDispatch, useSelector } from "react-redux";
import useTransactionColumns from "../Hook/useTransactionColumns";
import { useEffect, useState } from "react";
import { getFilteredDataWithTabs } from "../../../../Utils/CommonService";
import {
  setEditManualPaymentModalDropdown,
  setHandleManualPaymentModal,
  setManualPaymentDetails,
  setSelectedTransactionData,
} from "../../../../slices/orders/orderSlice";
import SplitInfoModal from "../Modal/SplitInfoModal";
import ManualPaymentModal from "../Modal/ManualPaymentModal";
import { resetFormState } from "../../../../slices/common/reducer";
import { checkButtonAccess } from "../../../../Utils/CommonUtils";

const Transactions = () => {
  const dispatch = useDispatch();

  const addManualPayment = useSelector(
    (state) => state.order.selectedOrders.handleManualPaymentModal
  );

  const manualData = useSelector(
    (state) => state.order.selectedOrders.manualPaymentDetails
  );

  const [showSplitInfoModal, setShowSplitInfoModal] = useState(false);

  const [selectedTransactionEntityId, setSelectedTransactionEntityId] =
    useState(null);

  const handleSplitInfoModalOpen = (data) => {
    setSelectedTransactionEntityId(data);
    setShowSplitInfoModal(true);
  };

  const handleManualPaymentModalClose = () => {
    dispatch(setHandleManualPaymentModal(false));

    dispatch(setManualPaymentDetails({}));
    resetFormState();
  };

  const handleManualPaymentModalOpen = () => {
    dispatch(setHandleManualPaymentModal(true));
    resetFormState();
  };

  useEffect(() => {
    resetFormState();
  }, []);
  const { transactionColumn } = useTransactionColumns(
    handleSplitInfoModalOpen,
    handleManualPaymentModalOpen
  );

  const transactionData = useSelector(
    (state) => state.order.selectedOrders.selectedTransactionData || []
  );

  const totalRows = transactionData.length;

  const selectedOrder = useSelector(
    (state) => state.order.selectedOrders.detailsData
  );

  const showAddPaymentBtn = () => {
    let check = checkButtonAccess("ADD_PAYMENT", "ORD_ORDS");
    let show = false;
    //permission check
    if (check) {
      if (
        selectedOrder.status === "PAYMENT_PENDING" ||
        selectedOrder.status === "PAYMENT_FAILED"
      ) {
        const manualData = transactionData.some(
          (entity) => entity.payment_type === "MANUAL_PAYMENT"
        );
        if (!manualData) {
          return true;
        }
      }
    }

    return show;
  };

  return (
    <div>
      <CommonHeader
        title={"Add Payment"}
        addClickHandler={handleManualPaymentModalOpen}
        showAddBtn={showAddPaymentBtn()}
      />
      <div className="drill-table-mapping">
        {/* {transactionData.length > 0 ? ( */}
        <TableWrapper
          columns={transactionColumn}
          data={transactionData}
          totalRows={totalRows}
          filterApi={true}
          filterForm={true}
          filterApiEntity={"PMT"}
          filterApiListEntity={"ODRT"}
          filterApiFunction={setSelectedTransactionData}
          filterApiService={getFilteredDataWithTabs}
          parentId2={selectedOrder.entityid}
          parentType={"ODR"}
        />
        {/* ) : (
          <p>No records found</p>
        )} */}
      </div>
      {showSplitInfoModal && (
        <SplitInfoModal
          selectedTransactionEntityId={selectedTransactionEntityId}
          show={showSplitInfoModal}
          onHide={setShowSplitInfoModal}
        />
      )}
      <ManualPaymentModal
        modalShow={addManualPayment}
        handleClose={handleManualPaymentModalClose}
      />
    </div>
  );
};

export default Transactions;
